
if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						const mergeInput = item.querySelector('input[name="updates[]"]');
						const mergedKeysRaw = mergeInput ? mergeInput.getAttribute('data-merged_keys') : '';

						let mergedKeys = [];

						if (mergedKeysRaw) {
							mergedKeys = mergedKeysRaw
								.split(',')
								.map(k => k.trim())
								.filter(k => k.length > 0);
						}

						if (mergedKeys.length > 0) {

							// 🔒 Atomic cart update using KEYS
							const updateData = {};

							mergedKeys.forEach(key => {
								updateData[key] = 0; // remove each merged line
							});
							$('.cart__form').addClass("processing");
							$.ajax({
								type: 'POST',
								url: '/cart/update.js',
								dataType: 'json',
								data: {
									updates: updateData
								}
							})
							.done(function (cart) {
								console.log('Merged items removed:', cart);
								window.refreshCart();
							})
							.fail(function (jqXHR, textStatus, errorThrown) {
								console.error('Cart update failed:', jqXHR.responseText);
								window.refreshCart(); // avoid stale UI
							});

						} else {
							// fallback: normal single-line update
							this.updateCartQty(item, 0);
						}

					})
				}

				const qty = item.querySelector('.qty');
				if (qty) {
					// Fixed: removed e.target.blur() that cancelled mid-typing on
					// mobile, and now reads server-fresh state instead of stale
					// DOM data-qty. Use 'change' (fires on blur) as primary trigger
					// for typed values, plus a long-debounced 'input' as a fallback.
					var applyTypedQty = async function () {
						if ($('.cart__form').hasClass('processing')) return;
						let desiredQty = parseInt(qty.value, 10);
						if (isNaN(desiredQty) || desiredQty < 0) return;
						const maxQty = parseInt(qty.getAttribute('max') || '9999', 10);
						if (maxQty && desiredQty > maxQty) {
							desiredQty = maxQty;
							qty.value = maxQty;
						}
						const mergedKeysRaw = qty.getAttribute('data-merged_keys') || item.dataset.merged_keys || '';
						const mergedKeys = mergedKeysRaw.split(',').map(k => k.trim()).filter(Boolean);

						if (mergedKeys.length === 0) {
							// Single-line cart row — use the existing fallback
							this.updateCartQty(item, desiredQty);
							return;
						}
						// Multi-line merged row: redistribute by putting all into the first
						// merged key and zeroing the rest. Fetch fresh /cart.js for state.
						$('.cart__form').addClass('processing');
						try {
							const fresh = await fetch('/cart.js').then(r => r.json());
							const keyExists = new Set(fresh.items.map(i => i.key));
							const usable = mergedKeys.filter(k => keyExists.has(k));
							const updates = {};
							usable.forEach((k, idx) => {
								updates[k] = idx === 0 ? desiredQty : 0;
							});
							await fetch('/cart/update.js', {
								method: 'POST',
								headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
								body: JSON.stringify({ updates })
							});
						} catch (err) {
							console.error('Typed-qty update failed:', err);
						} finally {
							window.refreshCart && window.refreshCart();
						}
					}.bind(this);

					qty.addEventListener('change', applyTypedQty);
					qty.addEventListener('input', debounce(applyTypedQty, 700));
					qty.addEventListener('click', e => { e.target.select(); });
					qty.addEventListener('keydown', e => {
						if (e.key === 'Enter') {
							e.preventDefault();
							qty.blur(); // triggers 'change'
						}
					});
				
				}

			})

			console.log("data test");

		}

		updateCartQty(item, newQty){
			console.log("itemitem");
			console.log(item);
			var item_qty_limit = item.querySelector('input[name="updates[]"]').getAttribute("max");
			document.querySelectorAll('.limit_qty').forEach(el => el.remove());
			if(newQty > item_qty_limit){
				item.querySelector('[name="updates[]"]').value = item_qty_limit;
				item.querySelector('.cart-item__actions').insertAdjacentHTML("afterend", "<p class='limit_qty'>Limit Reached QTY: "+ item_qty_limit +"</p>");
				return false;
			}else{
				let alert = null;

				this.form.classList.add('processing');
				if ( this.querySelector('.alert') ) {
					this.querySelector('.alert').remove();
				}

				const body = JSON.stringify({
					line: parseInt(item.dataset.line),
					quantity: newQty
				});

				fetch(KROWN.settings.routes.cart_change_url, {
						method: 'POST',
						headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
						body
					})
					.then(response => response.json())
					.then(response => {
						if ( response.status == 422 ) {
							// wrong stock logic alert
							alert = document.createElement('span');
							alert.classList.add('alert', 'alert--error');
							if ( typeof response.description === 'string' ) {
								alert.innerHTML = response.description;
							} else {
								alert.innerHTML = response.message;
							}
						}
						window.cart_limit_atc_qty_inc();
						return fetch('?section_id=helper-cart');
					})
					.then(response => response.text())
					.then(text => {

						const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
						const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
						const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

						const cartItems = document.getElementById('AjaxCartForm');
						cartItems.innerHTML = cartFormInnerHTML;
						cartItems.ajaxifyCartItems();

						document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
							elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
						});
						document.querySelectorAll('[data-header-cart-total]').forEach(elm=>{
							elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
						});

						if ( alert !== null ) {
							this.form.prepend(alert);
						} 

						document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
								
						const event = new Event('cart-updated');
						this.dispatchEvent(event);

					})
					.catch(e => {
						console.log(e);
						let alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						alert.textContent = KROWN.settings.locales.cart_general_error;
						this.form.prepend(alert);
					})
					.finally(() => {
						this.form.classList.remove('processing');
					});
			}
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

// if ( typeof CartProductQuantity !== 'function' ) {

// 	class CartProductQuantity extends HTMLElement {
// 		constructor(){
// 			super();
// 			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
// 			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
// 		}
// 		changeCartInput(){
// 			setTimeout(()=>{
// 				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
// 			}, 50);
// 		}
// 	}

//   if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
// 		customElements.define('cart-product-quantity', CartProductQuantity);
// 	}

// }
if (typeof CartProductQuantity !== 'function') {

  class CartProductQuantity extends HTMLElement {
    constructor() {
      super();

      this.btnMinus = this.querySelector('.qty-minus');
      this.btnPlus  = this.querySelector('.qty-plus');
      this.input    = this.querySelector('.qty');

      this.btnMinus.addEventListener('click', e => {
        e.preventDefault();
        this.handleChange(-1);
      });

      this.btnPlus.addEventListener('click', e => {
        e.preventDefault();
        this.handleChange(1);
      });
    }

    handleChange(delta) {
      if (this._inflight) {
        // Queue this click to run after the previous one settles.
        this._inflight = this._inflight.then(() => this._doChange(delta));
        return;
      }
      this._inflight = this._doChange(delta);
    }

    _doChange(delta) {
      const item = this.closest('[data-js-cart-item]');
      if (!item) return;

      const mergedAttr = item.getAttribute('data-merged_keys') || '';
      const keys = mergedAttr
        .split(',')
        .map(k => k.trim())
        .filter(Boolean);
		console.log(keys);
      if (!keys.length) return;

      const max = parseInt(this.input.getAttribute('max') || 9999, 10);
	  $('.cart__form').addClass("processing");
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          // Map current quantities by key
          const qtyMap = {};
          cart.items.forEach(i => {
            if (keys.includes(i.key)) {
              qtyMap[i.key] = i.quantity;
            }
          });

          // Current merged total
          const currentTotal = Object.values(qtyMap)
            .reduce((a, b) => a + b, 0);

          // Desired total
          let desiredTotal = currentTotal + delta;
          desiredTotal = Math.max(0, Math.min(max, desiredTotal));

          // If no change, stop
          if (desiredTotal === currentTotal) return;

          // Update input immediately
          this.input.value = desiredTotal;

          // Redistribute quantities
          const updates = {};
          let remaining = desiredTotal;

          keys.forEach((key, index) => {
            if (remaining <= 0) {
              updates[key] = 0;
              return;
            }

            // Put everything into first key, zero others
            if (index === 0) {
              updates[key] = remaining;
              remaining = 0;
            } else {
              updates[key] = 0;
            }
          });

          // Atomic update
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({ updates })
          });
        })
        .then(() => {
          window.refreshCart && window.refreshCart();
        })
        .catch(err => {
          console.error('Cart quantity update failed:', err);
          window.refreshCart && window.refreshCart();
        })
        .finally(() => { this._inflight = null; });
    }
  }

  if (!customElements.get('cart-product-quantity')) {
    customElements.define('cart-product-quantity', CartProductQuantity);
  }
}



// method for apps to tap into and refresh the cart

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

			const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
			const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
			const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

			const cartItems = document.getElementById('AjaxCartForm');
			cartItems.innerHTML = cartFormInnerHTML;
			cartItems.ajaxifyCartItems();

			document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
			});
			document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
				elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
			})
			
			document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
			if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
				document.querySelector('[data-js-site-cart-sidebar]').show();
			}

			if ( document.querySelector('cart-recommendations') ) {
				document.querySelector('cart-recommendations').innerHTML = '';
				document.querySelector('cart-recommendations').generateRecommendations();
			}

			$('.cart__form').removeClass("processing");
		})

	}

}

if ( ! customElements.get('cart-note') ) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'input',
          debounce(event => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${KROWN.settings.routes.cart_update_url}`, { 
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body 
						});
		  		}, 150)
				);
      }
    }
  );
}

if ( ! customElements.get('cart-discounts' ) ) {
	customElements.define(
		'cart-discounts',
		class CartDiscounts extends HTMLElement {

			constructor() {
				super();

				const button = this.querySelector('[data-js-discount-submit]');
				this.input = this.querySelector('[data-js-discount-input]');
				this.cartSubtotal = document.getElementById('AjaxCartSubtotal');
				this.cartDiscountError = this.querySelector('[data-js-discount-error]');
				this.discountCodes = document.querySelector('[data-js-discount-codes]');

				this.loadDiscountButtons();

				button.addEventListener('click', (e) => {
					e.preventDefault();
					if ( this.input.value.length > 0 ) {

						this.cartSubtotal.classList.add('processing');
						if (this.discountCodes) {
							this.discountCodes.classList.add('processing');
						}

						const existingDiscounts = Array.from(this.querySelectorAll('[data-js-discount]')).map(elm => elm.dataset.jsDiscount);
						
						const allDiscounts = [...existingDiscounts, this.input.value];
						const discountString = allDiscounts.join(',');
						const body = JSON.stringify({ discount: discountString });

						fetch(`${KROWN.settings.routes.cart_update_url}`, { 
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body 
						})
							.then(response => response.json())
							.then(response => {
								const discountCodes = response.discount_codes;
								const inputValue = this.input.value;
								const matchingCode = discountCodes.find(code => 
									code.code === inputValue
								);

								if (matchingCode) {
									if (matchingCode.applicable) {
										this.handleSuccess();
									} else {
										this.handleError();
									}
								} else {
									this.handleError();
								}
							})
							.catch(error => {
								this.handleError();
								console.log(`Error: ${error}`);
							})

					}

				});

			}

			handleSuccess(){
				fetch('?section_id=helper-cart')
					.then(response => response.text())
					.then(text => {
						const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
						const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;
						this.cartSubtotal.innerHTML = cartSubtotalInnerHTML;
						this.cartSubtotal.classList.remove('processing');
						this.cartDiscountError.innerHTML = '';
						if ( sectionInnerHTML.querySelector('[data-js-discount-codes]') ) {
							this.discountCodes.innerHTML = sectionInnerHTML.querySelector('[data-js-discount-codes]').innerHTML;
							this.discountCodes.classList.remove('processing');
							this.loadDiscountButtons();
						}
						this.input.value = '';
					})
			}

			loadDiscountButtons(){
				this.querySelectorAll('[data-js-discount]').forEach(elm=>{
					if ( ! elm.classList.contains('enabled') ) {
						elm.classList.add('enabled');
						elm.addEventListener('click', (e)=>{
							e.preventDefault();
							this.cartSubtotal.classList.add('processing');
							if (this.discountCodes) {
								this.discountCodes.classList.add('processing');
							}
							const discountToRemove = elm.dataset.jsDiscount;
							
							const allDiscountElements = this.querySelectorAll('[data-js-discount]');
							const allDiscounts = Array.from(allDiscountElements).map(el => el.dataset.jsDiscount);
							
							const remainingDiscounts = allDiscounts.filter(discount => discount !== discountToRemove);
							
							const body = JSON.stringify({ 
								discount: remainingDiscounts.join(',') 
							});
							
							fetch(`${KROWN.settings.routes.cart_update_url}`, { 
								method: 'POST',
								headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
								body 
							})
								.then(() => {
									this.handleSuccess();
								})
								.catch(error => {
									console.error(`Error: ${error}`);
								});
						});
					}
				});
			}
			
			handleError(){
				this.cartSubtotal.classList.remove('processing');
				if (this.discountCodes) {
					this.discountCodes.classList.remove('processing');
				}
				this.cartDiscountError.innerHTML = window.KROWN.settings.locales.cart_discount_code_error;
			}

		}	
	)
}

async function removeClosedCartItems() {
    try {
      const response = await fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      });

      if (!response.ok) return;

      const cart = await response.json();
      const closedStatus = window.cartItemClosedStatus || {};

      const closedItems = cart.items.filter((item) => closedStatus[item.key] === true);

      if (!closedItems.length) return;

      await Promise.all(
        closedItems.map((item) =>
          fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              id: item.key,
              quantity: 0
            })
          })
        )
      );

      window.refreshCart();
    } catch (error) {
      console.error('Failed to remove closed cart items:', error);
    }
  }

  document.addEventListener('DOMContentLoaded', removeClosedCartItems);